/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Devices_LabelInputs */

const en_why_listening_devices_label = /** @type {(inputs: Why_Listening_Devices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every device`)
};

const es_why_listening_devices_label = /** @type {(inputs: Why_Listening_Devices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los dispositivos`)
};

/**
* | output |
* | --- |
* | "Every device" |
*
* @param {Why_Listening_Devices_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_devices_label = /** @type {((inputs?: Why_Listening_Devices_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Devices_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_devices_label(inputs)
	return en_why_listening_devices_label(inputs)
});